import React, { useContext } from 'react';
import AppContext from 'context/Context';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPhone, faSpinner } from '@fortawesome/free-solid-svg-icons';

const AssignPhoneConfirmModal = ({
  show,
  previousOwner,
  pendingClient,
  ticketPhone,
  isAssigning,
  onConfirm,
  onReject,
  onCancel
}) => {
  const { config: { isDark: contextIsDark } = {} } = useContext(AppContext);
  const isDark = (typeof document !== 'undefined' && (
    document.documentElement.classList.contains('dark') ||
    document.body.classList.contains('dark')
  )) || Boolean(contextIsDark);

  if (!show) return null;

  return (
    <div
      className="modal fade show d-block"
      tabIndex="-1"
      style={{
        backgroundColor: isDark ? 'rgba(0, 0, 0, 0.65)' : 'rgba(0, 0, 0, 0.45)',
        zIndex: 1080
      }}
      onClick={() => !isAssigning && onCancel()}
    >
      <div
        className="modal-dialog modal-dialog-centered"
        style={{ maxWidth: '440px' }}
        onClick={e => e.stopPropagation()}
      >
        <div
          className="modal-content shadow-lg"
          style={{
            borderRadius: '12px',
            overflow: 'hidden',
            backgroundColor: isDark ? '#121e2d' : '#ffffff',
            border: isDark ? '1px solid #233142' : '1px solid #e2e8f0',
            color: isDark ? '#f9fafd' : '#0f172a'
          }}
        >
          {/* Header */}
          <div
            className="modal-header py-3 px-4 d-flex align-items-center justify-content-between"
            style={{
              borderBottom: isDark ? '1px solid #233142' : '1px solid #e2e8f0',
              backgroundColor: isDark ? '#182635' : '#ffffff'
            }}
          >
            <div className="d-flex align-items-center gap-2">
              <div
                className="rounded-circle d-flex align-items-center justify-content-center"
                style={{
                  width: '32px',
                  height: '32px',
                  backgroundColor: previousOwner
                    ? (isDark ? 'rgba(234, 88, 12, 0.2)' : '#fff7ed')
                    : (isDark ? 'rgba(22, 163, 74, 0.2)' : '#f0fdf4'),
                  color: previousOwner
                    ? (isDark ? '#fb923c' : '#ea580c')
                    : (isDark ? '#4ade80' : '#16a34a'),
                  fontSize: '0.85rem'
                }}
              >
                <FontAwesomeIcon icon={faPhone} />
              </div>
              <h6
                className="modal-title fw-bold mb-0"
                style={{
                  fontSize: '0.95rem',
                  color: isDark ? '#ffffff' : '#0f172a'
                }}
              >
                {previousOwner ? 'Cambiar titularidad del número' : 'Asignar número a cliente'}
              </h6>
            </div>
            <button
              type="button"
              className={`btn-close ${isDark ? 'btn-close-white' : ''}`}
              onClick={onCancel}
              disabled={isAssigning}
            />
          </div>

          {/* Body */}
          <div className="modal-body p-4 text-center">
            {previousOwner ? (
              <>
                <p className="mb-2 fw-bold" style={{ fontSize: '1.02rem', color: isDark ? '#f87171' : '#dc2626' }}>
                  Este número pertenece a #{previousOwner.idClienteAkasia} - {previousOwner.vNombreCompleto}
                </p>
                <p className="mb-3 fw-bold" style={{ fontSize: '0.95rem', color: isDark ? '#ffffff' : '#0f172a' }}>
                  ¿Deseas asignar este número a este cliente para futuros contactos?
                </p>
              </>
            ) : (
              <p className="mb-3 fw-bold" style={{ fontSize: '1.02rem', color: isDark ? '#ffffff' : '#0f172a' }}>
                ¿Quieres asignar este número a este cliente para futuros contactos?
              </p>
            )}

            <div
              className="p-3 rounded mb-2 text-start"
              style={{
                backgroundColor: isDark ? '#182635' : '#f8fafc',
                border: isDark ? '1px solid #233142' : '1px solid #e2e8f0'
              }}
            >
              {previousOwner && (
                <div
                  className="d-flex justify-content-between align-items-center mb-2 pb-2"
                  style={{
                    fontSize: '0.85rem',
                    borderBottom: isDark ? '1px solid #233142' : '1px solid #e2e8f0'
                  }}
                >
                  <span style={{ color: isDark ? '#94a3b8' : '#64748b' }}>Dueño actual:</span>
                  <span className="fw-bold text-end" style={{ color: isDark ? '#f87171' : '#dc2626' }}>
                    #{previousOwner.idClienteAkasia} - {previousOwner.vNombreCompleto}
                  </span>
                </div>
              )}
              <div className="d-flex justify-content-between align-items-center mb-2" style={{ fontSize: '0.85rem' }}>
                <span style={{ color: isDark ? '#94a3b8' : '#64748b' }}>
                  {previousOwner ? 'Nuevo cliente:' : 'Cliente:'}
                </span>
                <span className="fw-bold text-end" style={{ color: isDark ? '#ffffff' : '#0f172a' }}>
                  #{pendingClient?.idClienteAkasia} - {pendingClient?.vNombreCompleto || 'Cliente'}
                </span>
              </div>
              <div className="d-flex justify-content-between align-items-center" style={{ fontSize: '0.85rem' }}>
                <span style={{ color: isDark ? '#94a3b8' : '#64748b' }}>Número WhatsApp:</span>
                <span className="fw-bold" style={{ fontSize: '0.95rem', color: isDark ? '#34d399' : '#16a34a' }}>
                  {ticketPhone}
                </span>
              </div>
            </div>

            <small style={{ fontSize: '0.75rem', display: 'block', color: isDark ? '#94a3b8' : '#64748b' }}>
              {previousOwner
                ? `Al confirmar, el número se transferirá y se desactivará en el cliente #${previousOwner.idClienteAkasia} para quedar activo en #${pendingClient?.idClienteAkasia}.`
                : 'El número se vinculará a los teléfonos adicionales del cliente para que sus futuros mensajes se asocien automáticamente.'}
            </small>
          </div>

          {/* Footer: solo Sí o No */}
          <div
            className="modal-footer py-2 px-3 justify-content-end gap-2"
            style={{
              borderTop: isDark ? '1px solid #233142' : '1px solid #e2e8f0',
              backgroundColor: isDark ? '#182635' : '#f8fafc'
            }}
          >
            <button
              type="button"
              className="btn btn-sm px-3 shadow-none fw-semibold"
              onClick={onReject || onCancel}
              disabled={isAssigning}
              style={{
                fontSize: '0.82rem',
                borderRadius: '6px',
                backgroundColor: isDark ? '#1e293b' : '#ffffff',
                color: isDark ? '#38bdf8' : '#0284c7',
                border: isDark ? '1px solid #334155' : '1px solid #cbd5e1',
                transition: 'all 0.15s ease'
              }}
            >
              No
            </button>
            <button
              type="button"
              className={`btn btn-sm ${previousOwner ? 'btn-warning text-dark fw-bold' : 'btn-primary text-white'} px-3 d-inline-flex align-items-center gap-1 shadow-none`}
              onClick={onConfirm}
              disabled={isAssigning}
              style={{ fontSize: '0.82rem', fontWeight: 600, borderRadius: '6px' }}
            >
              {isAssigning ? (
                <>
                  <FontAwesomeIcon icon={faSpinner} spin className="me-1" />
                  Asignando...
                </>
              ) : (
                'Sí'
              )}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AssignPhoneConfirmModal;
